import PinsContainer from './container';
import Pins, { PinsDispatchProps, PinsProps } from './Pins';

export type PinsProps = PinsProps;
export type PinsDispatchProps = PinsDispatchProps;

export { Pins };
export default PinsContainer;
